import { PrimaryLinkArrow } from '../../../styles';
import {
  companyLinks,
  ourValuesLinks,
  primaryLink,
  subtitle,
} from '../../data/whyThriventConstants';
import {
  LinksColumnTitle,
  LinksContainer,
  LinksSubContainer,
  MobileMenuPrimaryLink,
  NavLink,
  SectionSubTitle,
  SectionTitle,
  TitleContainer,
} from '../mobileMenu.style';

export const WhyThriventMobileMenu = () => {
  return (
    <>
      <TitleContainer>
        <SectionTitle>Why Thrivent</SectionTitle>
        <SectionSubTitle>{subtitle}</SectionSubTitle>
        <MobileMenuPrimaryLink href={primaryLink.href}>
          {primaryLink.text} <PrimaryLinkArrow />
        </MobileMenuPrimaryLink>
      </TitleContainer>
      <LinksContainer>
        <LinksSubContainer>
          <LinksColumnTitle>{companyLinks.title}</LinksColumnTitle>
          {companyLinks.links.map((companyLink) => (
            <NavLink key={companyLink.text} href={companyLink.href}>
              {companyLink.text}
            </NavLink>
          ))}
        </LinksSubContainer>
        <LinksSubContainer>
          <LinksColumnTitle>{ourValuesLinks.title}</LinksColumnTitle>
          {ourValuesLinks.links.map((ourValuesLink) => (
            <NavLink key={ourValuesLink.text} href={ourValuesLink.href}>
              {ourValuesLink.text}
            </NavLink>
          ))}
        </LinksSubContainer>
      </LinksContainer>
    </>
  );
};
